import type { ComponentProps, ComponentType } from 'react';
import RawDatetime from 'react-datetime';

/**
 * react-datetime 2.16 honors closeOnTab at runtime, but the bundled DateTime.d.ts omits it.
 * Use this wrapper in .tsx files so closeOnTab type-checks without breaking export= module merging.
 */
export type BrandfolderReactDatetimeProps = ComponentProps<typeof RawDatetime> & {
  closeOnTab?: boolean;
};

const ReactDatetime = RawDatetime as ComponentType<BrandfolderReactDatetimeProps>;

export default ReactDatetime;
